import { SET_TERMS, SET_PRIVACY_POLICY } from '../types/types';

export const setTerms = (value) => {
  return {
    type: SET_TERMS,
    payload: { data: value},
  };
};

export const setPrivacyPolicy = (value) => {
  return {
    type: SET_PRIVACY_POLICY,
    payload: { data: value },
  };
};

